import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { IAccionesBotonDesplegable } from '../../services/boton-desplegable/boton-desplegable.service';

export interface IBotonCabecera {
  id: string;
  label: string;
  basic?: boolean;
  raised?: boolean;
  stroked?: boolean;
  fab?: boolean;
  miniFab?: boolean;
  flat?: boolean;
  color?: string;
  icono?: string;
  clase?: string;
  iconoClase?: string;
  activo?: boolean;
  disabled?: boolean;
  matprefix?: boolean;
  matsuffix?: boolean;
}

@Component({
  selector: 'neo-contenedor-cabecera[titulo]',
  templateUrl: './contenedor-cabecera.component.html',
  styleUrls: ['./contenedor-cabecera.component.scss']
})
export class ContenedorCabeceraComponent implements OnInit{

  @Input('titulo') titulo: string;
  @Input('estado') estado: string = '';
  @Input('principal') principal: boolean = false;
  @Input('tituloClase') tituloClase: string = 'cabecera-tit';
  @Input('paginaEnlace') paginaEnlace: string = '';
  @Input('idEntidadEnlace') idEntidadEnlace: string = '';
  @Input('subTitulo') subTitulo: string = '';
  @Input('botonera') botonera: IBotonCabecera[] | IAccionesBotonDesplegable[] = [];
  @Input('desplegable') desplegable: boolean = false;

  @Output() accionBoton = new EventEmitter<IBotonCabecera>();

  constructor(private router: Router) { }

  ngOnInit(){
    if (this.botonera && this.botonera.length) {
      this.botonera.forEach( boton => {
        // evitar que si activo matprefix, entonces este activo matsuffix
        if (boton?.matprefix) { boton.matsuffix = false}
        // por defecto activo matprefix como en logica boton
        if (!boton?.matprefix && !boton?.matsuffix) { boton.matprefix = true}
      })
    }
  }

  accion( boton: IBotonCabecera ) {
    this.accionBoton.emit(boton);
  }

  onEnlace() {
    if (this.paginaEnlace && this.paginaEnlace != '') {
      this.router.navigate([`/${this.paginaEnlace}`, this.idEntidadEnlace]);
    } else {
      return throwError(new Error('No se ha establecido pagia enlace para la redireccion de este contenedor'));
    }
  }

}
